import styled from 'styled-components'

const StepUi = styled.div`
  padding: 15px;
`

export default StepUi